export default "__VITE_ASSET__315026ba__"